var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"text-align":"left"}},[(_vm.modo=='new'||_vm.modo=='edit'||_vm.modo=='flow')?void 0:_vm._e(),(_vm.modo=='list' || _vm.modo=='view' || _vm.modo=='viewmode')?[_c('span',{class:{'text-xs-center':_vm.crud.action=='list'},domProps:{"innerHTML":_vm._s(_vm.displayvalue.replace(/\n/g, '<br/>'))}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }